import { PaginatedResult } from '@nx-smartmonkey/shared/interfaces';
import { Vehicle } from '../../domain/vehicle/Vehicle';
import { VehiclesTableColumn } from './tableColumns';

export enum VehicleActionType {
  SEARCH_VEHICLES_SUCCESS = `SEARCH_VEHICLES_SUCCESS`,
  SET_VEHICLES_TABLE_COLUMNS = `SET_VEHICLES_TABLE_COLUMNS`,
  GET_VEHICLE_AVATAR = `GET_VEHICLE_AVATAR`,
}

export interface SearchVehiclesSuccessAction {
  type: VehicleActionType.SEARCH_VEHICLES_SUCCESS;
  payload: {
    vehicles: PaginatedResult<Vehicle>;
  };
}

export interface SetVehiclesTableColumnsAction {
  type: VehicleActionType.SET_VEHICLES_TABLE_COLUMNS;
  payload: Array<VehiclesTableColumn>;
}

export interface GetVehicleAvatarAction {
  type: VehicleActionType.GET_VEHICLE_AVATAR;
  payload: {
    vehicleId: string;
    vehicleAvatar?: string;
  };
}

export type VehicleActions = SearchVehiclesSuccessAction | SetVehiclesTableColumnsAction | GetVehicleAvatarAction;
